import {batch} from 'react-redux';

import {
  getCurrentDeck,
  getDeckIndex,
  getDeckCount,
  getSlideIndex,
} from '../selectors/index';

import {SET_SEARCH_PARAMS, SLIDE_ROTATION_PAUSE_TOGGLE} from './ActionTypes';

function setSearchParams(params) {
  // The reason deckIndex and slideIndex can't be set in the same action is
  // that changing slideIndex will in turn change the currentSlideId, which
  // requires knowing what the order of slides is for the deck.
  // The solution is to dispatch the deckIndex change on its own, then dispatch
  // the slideIndex change; they can be wrapped with batch().
  if (params.deckIndex !== undefined && params.slideIndex !== undefined) {
    throw new Error('Cannot update deckIndex and slideIndex together');
  }

  return {
    type: SET_SEARCH_PARAMS,
    payload: params
  };
}

export const firstSlide = ({slideReferrer} = {}) => (dispatch, getState) => {
  return batch(() => {
    dispatch(setSearchParams({
      deckIndex: 0,
    }));

    const state = getState();
    const slideOrder = getCurrentDeck(state).slide_order;

    return dispatch(setSearchParams({
      slideIndex: 0,
      slideOrder,
      slideReferrer,
    }));
  });
};

export const lastSlide = ({slideReferrer} = {}) => (dispatch, getState) => {
  const state = getState();
  const deckCount = getDeckCount(state);
  const deckIndex = deckCount > 1 ? deckCount - 1 : getDeckIndex(state);

  return batch(() => {
    dispatch(setSearchParams({
      deckIndex,
    }));

    const state = getState();
    const currentDeck = getCurrentDeck(state);
    const slideOrder = currentDeck.slide_order;
    const slideIndex = slideOrder.length - 1;

    return dispatch(setSearchParams({
      slideIndex,
      slideOrder,
      slideReferrer,
    }));
  });
};

export const nextSlide = ({slideReferrer} = {}) => (dispatch, getState) => {
  const state = getState();
  const currentDeck = getCurrentDeck(state);
  const deckCount = getDeckCount(state);
  const deckIndex = getDeckIndex(state);
  const slideIndex = getSlideIndex(state);

  const slideCount = currentDeck.slide_order.length;

  return batch(() => {
    const isGoingToNextDeck = deckCount > 1 && slideIndex === slideCount - 1;

    if (isGoingToNextDeck) {
      dispatch(setSearchParams({
        deckIndex: (deckIndex + 1) % deckCount
      }));
    }

    const state = getState();
    const slideOrder = getCurrentDeck(state).slide_order;

    if (!currentDeck.id) {
      return;
    }

    const newSlideIndex = isGoingToNextDeck ? 0 : (slideIndex + 1) % slideCount;

    return dispatch(setSearchParams({
      slideIndex: newSlideIndex,
      slideOrder,
      slideReferrer,
    }));
  });
};

export const previousSlide = ({slideReferrer} = {}) => (dispatch, getState) => {
  const state = getState();
  const deckCount = getDeckCount(state);
  const deckIndex = getDeckIndex(state);
  const slideIndex = getSlideIndex(state);

  return batch(() => {
    const isGoingToPreviousDeck = deckCount > 1 && slideIndex === 0;

    if (isGoingToPreviousDeck) {
      dispatch(setSearchParams({
        deckIndex: deckIndex === 0 ? deckCount - 1 : deckIndex - 1
      }));
    }

    const state = getState();
    const currentDeck = getCurrentDeck(state);

    if (!currentDeck.id) {
      return;
    }

    const slideOrder = currentDeck.slide_order;
    const newSlideIndex = slideIndex === 0 ? slideOrder.length - 1 : slideIndex - 1;

    return dispatch(setSearchParams({
      slideIndex: newSlideIndex,
      slideOrder,
      slideReferrer,
    }));
  });
};

export const togglePauseSlideRotation = () => ({
  type: SLIDE_ROTATION_PAUSE_TOGGLE
});

export const setSlideIndex = (slideIndex, {slideReferrer} = {}) => (dispatch, getState) => {
  const state = getState();

  return dispatch(setSearchParams({
    slideIndex,
    slideOrder: getCurrentDeck(state).slide_order,
    slideReferrer,
  }));
};
